import { MutationHookOptions, gql } from '@apollo/client';

import { edeApplicationQuery } from 'routes/marketplace-ede/queries/ede/getEdeApplication';
import { useEdeMutation, useEdeQueryName } from 'routes/marketplace-ede/context/edeQueryProvider';

const queryType = 'REMOVE_MEMBER';

const useRemoveMemberMutation = (options: MutationHookOptions = {}) => {
  const queryName = useEdeQueryName(queryType);

  const REMOVE_MEMBER_MUTATION = gql`
    mutation RemoveEdeMember($appID: ID!, $productAppId: ID!, $payload: RemovedMemberInput!) {
      ${queryName} (appID: $appID, productAppId: $productAppId, payload: $payload) {
        ${edeApplicationQuery}
      }
    }
  `;

  return useEdeMutation(REMOVE_MEMBER_MUTATION, options);
};

export default useRemoveMemberMutation;
